// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ee471957","453":"ae070422","455":"ae9e6f8c","977":"b79ad773"}[chunkId] + ".chunk.js";
};